/**
 * @generated SignedSource<<bd4b14a0db44c7da7e39672faf308099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BusinessPlaceType = "etc" | "lease" | "noHave" | "own";
export type businessPlaceTypeQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessPlaceTypeQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly businessPlaceType: BusinessPlaceType | null | undefined;
      readonly businessPlaceTypeComment: string | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessPlaceTypeQuery = {
  response: businessPlaceTypeQuery$data;
  variables: businessPlaceTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "businessPlaceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "businessPlaceTypeComment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessPlaceTypeQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessPlaceTypeQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1efe3a6cbe0356fae4c03782837cb9b1",
    "id": null,
    "metadata": {},
    "name": "businessPlaceTypeQuery",
    "operationKind": "query",
    "text": "query businessPlaceTypeQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      businessPlaceType\n      businessPlaceTypeComment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f5790058343046e4562ea122e53a04d";

export default node;
